// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__CCBiU","title":"BackImages_title__25NiP","images":"BackImages_images__J-aMm"};